// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2ZemV","dropdown":"Header_dropdown__11EOq","searchIcon":"Header_searchIcon__1iLmx","logoImg":"Header_logoImg__2QJCk","dropDown":"Header_dropDown__24roZ"};